import React, { PropTypes, useEffect, useState, useRef } from "react";
import { Field } from "redux-form";
import { FormGroup, Button, Form, Alert, Label, Row, Col } from "reactstrap";
import classnames from "classnames";
import Autocomplete from "react-google-autocomplete";
import Modal from "pickups-ui-library/components/Modal";
import { FormField, IconItem, Loader, toastActions } from "pickups-ui-library";
import { getReverseGeocode } from "api/locations";
import FormNavigation from "../navigation.component";
import DropOffLocations from "../../../components/DropOffLocations";

import { getPickupBlockByType } from "utils/helpers";
import Tracking from "utils/tracking";

import * as Icons from "pickups-ui-library/styles/icons";

let NewZipSearchForm = (props) => {
  const {
    autofill,
    handleSubmit,
    invalid,
    zipCode,
    reset,
    submitFailed,
    destroy,
    pristine,
    submitting,
    error,
    pickupBlocks,
    dropOffLocations,
    addressSelected,
    makeSelection,
    submitSucceeded,
    onSubmitSucceeded,
    handleSelect,
    onClickAutoComplete,
    hasFurniture,
    requestLogin,
    user,
  } = props;

  const [geolocateLoading, setGeolocateLoading] = useState(false);
  const [noPickupBlocks, setNoPickupBlocks] = useState(false);
  const [zipCodeFound, setZipCodeFound] = useState(false);
  const [dropOffFound, setDropOffFound] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (zipCode && invalid) {
      autofill("zipCode", zipCode);
    }
  }, [zipCode, invalid]);

  let errorMessage;

  useEffect(() => {
    if (error) {
      if (error === "empty" && addressSelected) {
        setNoPickupBlocks(true);
        Tracking.track("Step 1: No Pickup Blocks Found");
      } else {
        if (error.message) {
          errorMessage = error.message;
        }
      }
    }

    if (!addressSelected) {
      setNoPickupBlocks(false);
    }
  }, [error, addressSelected]);

  const PickupBlockResponse = (props) => {
    const { pickupBlocks, dropOffLocations } = props;

    return (
      <div>
        {dropOffLocations.length > 0 ? (
          <>
            <Alert
              color="success"
              onClick={() => {
                setShowModal(true);
              }}
            >
              {dropOffLocations.length} drop-off locations near {zipCode}{" "}
              <Button size="sm" className="float-sm-right ml-sm-2 mt-md-0">
                View Locations
              </Button>
            </Alert>
            <Modal
              show={showModal}
              title={
                <small>
                  {dropOffLocations.length} drop-off locations near {zipCode}
                </small>
              }
              onHide={() => {
                setShowModal(false);
              }}
            >
              <DropOffLocations locations={dropOffFound} />
            </Modal>
          </>
        ) : null}

        {pickupBlocks.length ? (
          <div>
            <Alert color="success">
              Donation pickups are available in your area, please continue.
            </Alert>
          </div>
        ) : null}

        {zipCodeFound && noPickupBlocks ? (
          <Alert color="success">
            We offer donation pickups in your area, but there are currently no
            stops available. <br />
            Please check back on Monday. (
            <a
              href="#"
              onClick={() => {
                onClickAutoComplete();
              }}
            >
              Search a different address
            </a>
            )<div className="pull-right" />
          </Alert>
        ) : null}

        {!zipCodeFound && noPickupBlocks ? (
          <Alert color="warning">
            Sorry, we don't offer donation pickups in your area. (
            <a
              href="#"
              onClick={() => {
                onClickAutoComplete();
              }}
            >
              Search a different address
            </a>
            )<div className="pull-right" />
          </Alert>
        ) : null}
      </div>
    );
  };

  const handleGeolocateClick = async () => {
    await setGeolocateLoading(true);

    if (navigator.geolocation) {
      await navigator.geolocation.getCurrentPosition(
        async ({ coords }) => {
          const { latitude, longitude } = coords;
          const latLng = `${latitude}, ${longitude}`;
          const { data } = await getReverseGeocode(latLng);

          if (data.results.length) {
            handleSelect(
              data.results[0],
              setNoPickupBlocks,
              setZipCodeFound,
              setDropOffFound
            );
            return setGeolocateLoading(false);
          } else {
            toastActions.showToast({
              message: "Something went wrong, cannot locate address",
              type: "error",
            });
            return setGeolocateLoading(false);
          }
        },
        ({ message }) => {
          const timeoutExpired = message === "Timeout expired";
          toastActions.showToast({
            message: `${message}. ${
              timeoutExpired
                ? "Check to see if location services is enabled"
                : ""
            }`,
            type: "error",
          });
          return setGeolocateLoading(false);
        },
        {
          timeout: 10000,
          enableHighAccuracy: true,
        }
      );
    } else {
      toastActions.showToast({
        message: "Your device does not support geolocation services",
        type: "error",
      });
      return setGeolocateLoading(false);
    }
  };

  const autocompliteInputRef = useRef(null);

  let addAlternateAction = {};
  // checking if there is an address selected and that there are no issues with the form
  const canSubmit = addressSelected && !errorMessage;

  return (
    <form onSubmit={handleSubmit}>
      <PickupBlockResponse
        pickupBlocks={pickupBlocks}
        dropOffLocations={dropOffLocations}
      />
      <div className={"box p-3"}>
        <Row>
          <Col xs="12" sm="9">
            <FormGroup
              className={classnames({
                "has-success": addressSelected,
              })}
            >
              <Label>Street Address</Label>
              {addressSelected ? (
                <div
                  className="form-control"
                  onClick={() => {
                    onClickAutoComplete();
                  }}
                >
                  {addressSelected}
                </div>
              ) : (
                // <Autocomplete
                //   // style={{width: '90%'}}
                //   apiKey={process.env.REACT_APP_GOOGLE_MAPS_API}
                //   className="form-control"
                //   onPlaceSelected={handleSelect}
                //   options={{
                //     componentRestrictions: {
                //       country: "US",
                //     },
                //     types: ["address"],
                //   }}
                // />
                <div className="pickup-block-form-autocomplete-container">
                  <Autocomplete // style={{width: '90%'}}
                    apiKey={process.env.REACT_APP_GOOGLE_MAPS_API}
                    ref={autocompliteInputRef}
                    className="form-control"
                    onPlaceSelected={(address) =>
                      handleSelect(
                        address,
                        setNoPickupBlocks,
                        setZipCodeFound,
                        setDropOffFound
                      )
                    }
                    options={{
                      componentRestrictions: {
                        country: "US",
                      },
                      types: ["address"],
                    }}
                  />
                  <Button
                    id="pickup-block-form-geolocate-button"
                    onClick={handleGeolocateClick}
                  >
                    {geolocateLoading ? (
                      <Loader color="#fff" />
                    ) : (
                      <IconItem Icon={Icons.LocationArrow} />
                    )}
                  </Button>
                </div>
              )}
            </FormGroup>
          </Col>
          <Col xs="12" sm="3">
            <Field
              label={"Unit"}
              heading={"Unit"}
              name={"unit"}
              component={FormField}
            />
          </Col>
        </Row>

        <Field
          type={"hidden"}
          heading={"Unit"}
          name={"zipCode"}
          component={FormField}
          required={true}
        />
      </div>
      <FormNavigation isDisabled={!canSubmit || noPickupBlocks} {...props} />

      {errorMessage ? <Alert color="danger">{errorMessage}</Alert> : null}
    </form>
  );
};
//
// NewZipSearchForm.propTypes = {
//     handleSubmit : PropTypes.func.isRequired,
//     initialValues : PropTypes.object,
// }

export default NewZipSearchForm;
